/*
** Compute percentage of window height
*/

export const vh = x => x/100 * window.innerHeight
